import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function fetchDocsBar() {
  return api.getJson('/portal/api/v2/darts-docs/side-bar', {}, credentialsConf);
}

export function fetchApi({ apiId }) {
  return api.getJson(`/portal/api/darts-docs/api/${apiId}`, {}, credentialsConf);
}

export function fetchGroupApis({ groupId }) {
  return api.getJson(`/portal/api/v2/darts-docs/side-bar/group/${groupId}`);
}
